import { DestroyRef, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatPaginatorIntl } from "@angular/material/paginator";

import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class PaginatorHelper extends MatPaginatorIntl {
  constructor(
    private translate: TranslateService,
    private destroy: DestroyRef
  ) {
    super();
    this.translateLabels();

    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((): void => {
        this.translateLabels();
      });
  }

  private translateLabels(): void {
    this.itemsPerPageLabel = this.translate.instant("ITEMS_PER_PAGE");
    this.nextPageLabel = this.translate.instant("NEXT_PAGE");
    this.previousPageLabel = this.translate.instant("PREVIOUS_PAGE");
    this.firstPageLabel = this.translate.instant("FIRST_PAGE");
    this.lastPageLabel = this.translate.instant("LAST_PAGE");

    this.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ): string => {
      if (length === 0 || pageSize === 0) {
        return this.translate.instant("NO_RESULTS");
      }
      const startIndex = page * pageSize + 1;
      const endIndex = Math.min((page + 1) * pageSize, length);
      return this.translate.instant("PAGE_RANGE", {
        startIndex,
        endIndex,
        length,
      });
    };

    this.changes.next();
  }
}
